import React, { useState } from 'react';

function Terms() {
  const [activeSection, setActiveSection] = useState('user');

  return (
    <div className="min-vh-100 bg-white py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold" style={{ color: '#000000' }}>Terms & Conditions</h1>
            </div>

            {/* Toggle Buttons */}
            <div className="text-center mb-4">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${activeSection === 'user' ? 'btn-dark text-white' : 'btn-outline-dark'}`}
                  onClick={() => setActiveSection('user')}
                >
                  User Terms & Conditions
                </button>
                <button
                  type="button"
                  className={`btn ${activeSection === 'driver' ? 'btn-dark text-white' : 'btn-outline-dark'}`}
                  onClick={() => setActiveSection('driver')}
                >
                  Driver Terms & Conditions
                </button>
              </div>
            </div>

            {/* User Terms */}
            {activeSection === 'user' && (
              <div className="terms-section">
                <h2 className="mb-4 border-bottom pb-2" style={{ color: '#000000' }}>User Terms & Conditions</h2>
                
                <div className="mb-4">
                  <h5 className="fw-bold text-dark">1. What are the age requirements for using Dailo?</h5>
                  <p className="text-muted">Users must be at least 18 years old to create an account and use our ride-sharing services.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">2. What payment methods are accepted?</h5>
                  <p className="text-muted">All ride bookings must be paid through the approved payment methods within the Dailo application only.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">3. What are my responsibilities for ride locations?</h5>
                  <p className="text-muted">Users are responsible for providing accurate pickup and destination locations to ensure smooth service.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">4. Are there cancellation fees?</h5>
                  <p className="text-muted">Cancellation fees may apply if rides are cancelled after the driver has accepted the booking request.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">5. What conduct is expected during rides?</h5>
                  <p className="text-muted">Users must not engage in any illegal activities and must maintain proper behavior and respect towards drivers.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">6. Are there restrictions in vehicles?</h5>
                  <p className="text-muted">Smoking and consumption of alcohol is strictly prohibited in all Dailo vehicles.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">7. What happens if I damage the vehicle?</h5>
                  <p className="text-muted">Users are liable for any damages caused to the vehicle during the ride and may be charged for repairs.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">8. How should I maintain my profile?</h5>
                  <p className="text-muted">Users must ensure their profile information is accurate and kept up-to-date for better service experience.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">9. What are the consequences of violating terms?</h5>
                  <p className="text-muted">Dailo reserves the right to suspend or terminate accounts that violate these terms and conditions.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">10. How can I contact customer support?</h5>
                  <p className="text-muted">For any queries or support, users can contact our customer service team through the app or email support@dailo.com.</p>
                </div>
              </div>
            )}

            {/* Driver Terms */}
            {activeSection === 'driver' && (
              <div className="terms-section">
                <h2 className="mb-4 border-bottom pb-2" style={{ color: '#000000' }}>Driver Terms & Conditions</h2>
                
                <div className="mb-4">
                  <h5 className="fw-bold text-dark">1. What documents are required to become a driver?</h5>
                  <p className="text-muted">Drivers must possess a valid driving license and all required vehicle documentation as per local regulations.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">2. What are the vehicle requirements?</h5>
                  <p className="text-muted">Vehicles must meet our safety standards, be properly maintained, and pass regular inspections.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">3. How should drivers behave with passengers?</h5>
                  <p className="text-muted">Drivers must maintain professional behavior and provide respectful service to all passengers.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">4. When should drivers accept ride requests?</h5>
                  <p className="text-muted">Acceptance of ride requests should be based on actual availability to ensure reliable service.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">5. What routes should drivers follow?</h5>
                  <p className="text-muted">Drivers must follow the recommended routes unless the passenger specifically requests an alternative route.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">6. Is insurance required?</h5>
                  <p className="text-muted">Proper insurance coverage for commercial ride-sharing activities is mandatory for all drivers.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">7. What is the policy on discrimination?</h5>
                  <p className="text-muted">Drivers must not discriminate against passengers based on race, gender, religion, or any other factors.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">8. How should vehicles be maintained?</h5>
                  <p className="text-muted">Maintaining vehicle cleanliness, hygiene, and proper working condition is required at all times.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">9. What traffic laws must be followed?</h5>
                  <p className="text-muted">Drivers must comply with all local traffic laws, regulations, and speed limits during rides.</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold text-dark">10. Are there regular checks on drivers?</h5>
                  <p className="text-muted">Dailo may conduct periodic background checks and vehicle inspections to ensure safety standards.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;